import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';
import { UiCoreModule } from '@softline/ui-core';

@Component({
  selector: 'soft-field-ok-fibper-list-view',
  imports: [UiCoreModule],
  templateUrl: './fibper.list-view.html',
  styleUrls: ['./fibper.list-view.css'],
})
export class FibperListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
